var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
export class QboTableSort extends LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'desc';
        this.selector = 'table';
        this.sortBy = null;
        /* Trigger for raising the sort event. */
        this.trigger = null;
        this.type = 'inline';
        this.table = null;
    }
    firstUpdated() {
        this.table = this.closest('table');
        if (this.table == null)
            return;
        this.table.addEventListener('click', this.sortTable.bind(this));
    }
    disconnectedCallback() {
        this.table?.removeEventListener('click', this.sortTable.bind(this));
    }
    sortInline(column) {
        const rows = Array.from(this.table.querySelector('tbody').querySelectorAll('tr'));
        const sortType = column.getAttribute('data-sort') || 'string';
        rows.sort((rowA, rowB) => {
            const cellA = rowA.cells[column.cellIndex].getAttribute('data-sort-value')
                ?? rowA.cells[column.cellIndex].textContent.trim();
            const cellB = rowB.cells[column.cellIndex].getAttribute('data-sort-value')
                ?? rowB.cells[column.cellIndex].textContent.trim();
            switch (sortType) {
                case 'numeric':
                    return this.direction === 'asc' ? Number(cellA) - Number(cellB) : Number(cellB) - Number(cellA);
                case 'date':
                    return this.direction === 'asc'
                        ? new Date(cellA).getTime() - new Date(cellB).getTime()
                        : new Date(cellB).getTime() - new Date(cellA).getTime();
                case 'string':
                default:
                    return this.direction === 'asc'
                        ? cellA.localeCompare(cellB)
                        : cellB.localeCompare(cellA);
            }
        });
        rows.forEach(row => this.table.querySelector('tbody').appendChild(row));
        const headers = this.table.querySelectorAll('th[data-sort]');
        headers.forEach(th => th.classList.remove('sorted-asc', 'sorted-desc'));
        column.classList.add(this.direction === 'asc' ? 'sorted-asc' : 'sorted-desc');
    }
    sortTable(event) {
        const target = event.target;
        const column = target?.closest('th');
        if (column == null || column.getAttribute('data-sort') == null)
            return;
        this.direction = this.direction === 'asc' ? 'desc' : 'asc';
        this.sortBy = column.getAttribute('data-sort') || column.innerText;
        let sortType = 'string';
        if (this.sortBy != null && this.sortBy.indexOf('|')) {
        }
        if (this.type !== 'remote')
            this.sortInline(column);
        this.dispatchEvent(new CustomEvent('sort', {
            detail: { sortBy: this.sortBy, direction: this.direction, source: event },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html ``; // The component itself doesn't render anything
    }
}
__decorate([
    property(),
    __metadata("design:type", String)
], QboTableSort.prototype, "direction", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboTableSort.prototype, "selector", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], QboTableSort.prototype, "sortBy", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboTableSort.prototype, "trigger", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboTableSort.prototype, "type", void 0);
if (!customElements.get('qbo-table-sort'))
    customElements.define('qbo-table-sort', QboTableSort);
